export default __webpack_public_path__ + "static/media/icon-turnon.47b4e777.svg";